export const HOME = '/';
export const PRESENT = '/present';
export const UPDATE = '/update';
export const PRINT = '/print';
